
import { Component, Prop, Vue } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";

@Component({})
export default class QueryComponent extends Vue {
  @Prop()
  public refresh;

  public contact: any = {
    name: null,
    email: null,
    message: null
  };

  public async submitQuery() {
      let result = await this.$validator.validateAll();
      if (result) {
        let response = await Axios.post(
          API_STORE.PRODUCT + "submitQuery",
          this.contact
        );
        if (response) {
        this.contact = {};
        this.$snotify.success(response.data);
        }
      } else {
        setTimeout(() => {
          this.clearFields();
        }, 2000);
      }
  }

  public clearFields() {
    this.$validator.errors.items = [];
  }
}
